import React from 'react';
import { Chip } from '@mui/material';
import {
  Person as EmployeeIcon,
  Badge as VisitorIcon,
  Engineering as ContractorIcon,
  Apartment as TenantIcon,
  PersonAdd as UnlistedIcon,
} from '@mui/icons-material';
import { PersonType } from '../../Types/enums';
import { getPersonTypeLabel } from '../../Utils/personTypeLabels';
import { appColors } from '../../Config/Theme';

interface PersonTypeChipProps {
  personType?: string | null;
  size?: 'small' | 'medium';
}

const TYPE_STYLES: Record<string, { bg: string; color: string; icon: React.ReactElement }> = {
  [PersonType.Employee]: { bg: '#E3F2FD', color: '#1565C0', icon: <EmployeeIcon sx={{ fontSize: 12 }} /> },
  [PersonType.Visitor]: { bg: '#FFF3E0', color: '#E65100', icon: <VisitorIcon sx={{ fontSize: 12 }} /> },
  [PersonType.Contractor]: { bg: '#F3E5F5', color: '#7B1FA2', icon: <ContractorIcon sx={{ fontSize: 12 }} /> },
  [PersonType.Tenant]: { bg: '#E0F2F1', color: '#00695C', icon: <TenantIcon sx={{ fontSize: 12 }} /> },
  [PersonType.Unlisted]: { bg: appColors.status.warningBg, color: appColors.status.warning, icon: <UnlistedIcon sx={{ fontSize: 12 }} /> },
};

const DEFAULT_STYLE = { bg: appColors.surface.inactive, color: appColors.text.caption, icon: <EmployeeIcon sx={{ fontSize: 12 }} /> };

const PersonTypeChip: React.FC<PersonTypeChipProps> = ({ personType, size = 'small' }) => {
  const label = getPersonTypeLabel(personType);
  if (!label) return null;

  const key = String(personType).toLowerCase().trim();
  const style = TYPE_STYLES[key] ?? DEFAULT_STYLE;

  return (
    <Chip
      label={label}
      size={size}
      icon={style.icon}
      sx={{
        height: 18,
        fontSize: '0.65rem',
        fontWeight: 600,
        bgcolor: style.bg,
        color: style.color,
        '& .MuiChip-icon': { color: style.color },
      }}
    />
  );
};

export default React.memo(PersonTypeChip);
